import React, { Component } from 'react';
import { colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Accordion from '@bitcoin-portal/bitcoincom-pkg-components/dist/Accordion';
import CaretDownSolid from '@bitcoin-portal/bitcoincom-pkg-components/dist/IconsNavigation/CaretDownSolid';
import CaretUpSolid from '@bitcoin-portal/bitcoincom-pkg-components/dist/IconsNavigation/CaretUpSolid';
import { FooterLink } from '../../styled';
import { sendAmpEvent } from '../../helpers';
class AccordionLink extends Component {
    constructor(props) {
        super(props);
        this.trackClick = (link) => {
            if (link.match('sell.bitcoin.com'))
                sendAmpEvent('sell_cta_clicked', {
                    web_location: 'footer',
                    pageview: window.location.href,
                });
            if (link.match('buy.bitcoin.com'))
                sendAmpEvent('buy_cta_clicked', {
                    web_location: 'footer',
                    pageview: window.location.href,
                });
        };
        this.trackClick = this.trackClick.bind(this);
    }
    render() {
        const { catTitle, catLink, sublinks } = this.props;
        return (React.createElement(Accordion, { items: [
                {
                    title: (React.createElement(FooterLink, { href: catLink, className: "universal-footer-link", onClick: () => {
                            this.trackClick(catLink);
                        } }, catTitle)),
                    content: sublinks.map((sublink) => {
                        return (React.createElement("div", { style: { marginLeft: '15px' }, key: sublink.message },
                            React.createElement(FooterLink, { href: sublink.href, className: "universal-footer-link", onClick: () => {
                                    this.trackClick(sublink.href);
                                } }, sublink.message)));
                    }),
                    icons: {
                        closed: React.createElement(CaretDownSolid, { size: 12, color: colors.solid.textTwo }),
                        opened: React.createElement(CaretUpSolid, { size: 12, color: colors.solid.textTwo }),
                    },
                },
            ] }));
    }
}
export default AccordionLink;
//# sourceMappingURL=AccordionLink.js.map